import { AircraftCategory } from '../types';

export const DEFAULT_PREP_TIMES: Record<AircraftCategory, number> = {
  [AircraftCategory.REGIONAL]: 45,
  [AircraftCategory.MEDIUM]: 60,
  [AircraftCategory.HEAVY]: 90,
};

export const DEFAULT_POST_ARRIVAL_TIME = 30; // minutes

export const FLIGHT_STATUS_COLORS: Record<string, string> = {
  SCHEDULED: '#6B7280',  // gray
  PREPARING: '#3B82F6',  // blue
  BOARDING: '#8B5CF6',   // purple
  DEPARTED: '#10B981',   // green
  EN_ROUTE: '#10B981',   // green
  ARRIVED: '#F59E0B',    // amber
  COMPLETED: '#059669',  // emerald
  CANCELLED: '#EF4444',  // red
  DELAYED: '#F97316',    // orange
  DIVERTED: '#DC2626',   // red
};

export const TASK_STATUS_COLORS: Record<string, string> = {
  PENDING: '#6B7280',
  ASSIGNED: '#3B82F6',
  IN_PROGRESS: '#F59E0B',
  COMPLETED: '#10B981',
  CANCELLED: '#EF4444',
  BLOCKED: '#DC2626',
  SKIPPED: '#9CA3AF',
};

export const MATERIAL_STATUS_COLORS: Record<string, string> = {
  AVAILABLE: '#10B981',
  IN_USE: '#3B82F6',
  OUT_OF_SERVICE: '#EF4444',
  MAINTENANCE: '#F59E0B',
};

export const API_ROUTES = {
  AUTH: {
    REQUEST_OTP: '/api/auth/otp/request',
    VERIFY_OTP: '/api/auth/otp/verify',
    LOGOUT: '/api/auth/logout',
  },
  FLIGHTS: '/api/flights',
  RESOURCES: '/api/resources',
  TASKS: '/api/tasks',
  SCHEDULING: '/api/scheduling',
  DASHBOARD: '/api/dashboard',
  NOTIFICATIONS: '/api/notifications',
  COSTS: '/api/costs',
  SETTINGS: '/api/settings',
  HISTORY: '/api/history',
  USERS: '/api/users',
  AIRPORTS: '/api/airports',
} as const;
